//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'BusinessResult',
    components: {
        MyBtnReturn
    },
    data() {
        return {
            tableData: [],
            // newData: [
            //   {
            //     contNo: 'asfasf',
            //     mblNo: 'aaaaaa',
            //     truckStatus: 0,
            //     loadOverStatus: 1,
            //     inVesselStatus: 0,
            //     isArrived: 0,
            //     goodsReliveStatus: 1,
            //     isGoodskeep: 0,
            //   },
            // ], // todo:虚假数据，模拟滚动加载新数据功能，后续注释
            radioIconGrey: require('@/assets/images/business/wx_wx_grey.png'),
            radioIconGreen: require('@/assets/images/business/wx_xz_green.png'),
            goodsKeepIcon1: require('@/assets/images/business/wx_fh_oringe.png'),
            goodsKeepIcon0: require('@/assets/images/business/wx_kx_blue.png'),
            canFetch: true, // false为阻止继续获取数据
            isShowLoading: false,
            isShowTable: true,
            pageSize: 5, // 告知后台一次传回几条表格数据，默认5
            pageNo: 1, // 当前为第几页数据，要累加
            totalCount: 0, // 表格数据总条数，后台返回，计算总页数totalPages
            totalPages: 2, // 总页数，初始化必须比pageNo大
            isNoData: false, // false代表还有数据
            tableDataUrl: apiUrl.businessTemplate, // 查询表单数据API，businessTemplate
        }
    },
    created() {
        document.title = '货物跟踪'
    },
    mounted() {
        // 要在这个钩子函数中才能一开始操作到scrollBottom标签
        this.onScrollBottom() // 组件被创建时，就先获取一次数据
    },
    methods: {
        getMoreData(url, data) {
            // 获取表格数据（分页数据）
            // 还要先判断到了最后一页了没
            if (this.pageNo > this.totalPages) {
                this.canFetch = true; // 要恢复可以获取状态，可继续提示暂无更多数据
                this.isShowLoading = false;
                this.$vux.toast.show({
                    text: '暂无更多数据！',
                    time: 2000,
                    position: 'middle'
                });
                return
            }
            // 调用接口获取数据
            this.requestApi({
                url: url,
                data: data,
            }, (resultData) => {
                let dataObj = resultData.data.page;
                let resultArr = dataObj.result || []; // 防止后台返回null
                if (resultArr.length === 0) {
                    // 如果没有数据，要告知用户
                    this.isNoData = true;
                    this.isShowLoading = false;
                    // 如果是第一页就没有数据，那隐藏scroller吧
                    if (this.pageNo === 1) {
                        this.isShowTable = false
                    }
                    return
                }
                resultArr.forEach((item) => {
                    this.tableData.push(item)
                }); // 表格数据是放在result中
                this.totalCount = dataObj.totalCount;
                this.totalPages = dataObj.totalPages;
                this.pageNo++;
                this.$nextTick(() => {
                    this.$refs.scrollerBottom.reset()
                }) // 要重置scroller组件
            }, (error) => {
                this.isShowLoading = false;
                this.canFetch = true;
                if (error) {
                    console.error(error);
                }
            })
        },
        onScrollBottom() {
            this.isShowLoading = true;
            let query = this.$route.query;
            let data = {
                cont_no: query.cont_no,
                m_bl_no: query.m_bl_no,
                lading_id: query.lading_id,
                consignee_id: query.consignee_id,
                datediff: query.datediff,
                pageSize: this.pageSize, // 告知后台一次传回几条表格数据，默认5
                pageNo: this.pageNo, // 当前为第几页数据，要累加
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
            };
            if (!this.canFetch) {
            } else {
                this.canFetch = false;
                this.getMoreData(this.tableDataUrl, data)
            }
        },
        editDate(data) {
            // 将'√18.02.27'这种数据弄成2018.02.27这样的
            if (data !== '×') {
                let reg = /\D*(.*)/;
                let date = '20' + data.match(reg)[1];
                return date
            } else {
                return null
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/kehu/business/businessResult/BusinessResult.vue